var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "-4 -4 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 7.7486H8.5C7.25736 7.7486 6.25 8.75596 6.25 9.9986V23.4986C6.25 24.7412 7.25736 25.7486 8.5 25.7486H23.5C24.7426 25.7486 25.75 24.7412 25.75 23.4986V9.9986C25.75 8.75596 24.7426 7.7486 23.5 7.7486Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 15.9986C18.4963 15.9986 19 15.4949 19 14.8736C19 14.2523 18.4963 13.7486 17.875 13.7486C17.2537 13.7486 16.75 14.2523 16.75 14.8736C16.75 15.4949 17.2537 15.9986 17.875 15.9986Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.625 15.9986C22.2463 15.9986 22.75 15.4949 22.75 14.8736C22.75 14.2523 22.2463 13.7486 21.625 13.7486C21.0037 13.7486 20.5 14.2523 20.5 14.8736C20.5 15.4949 21.0037 15.9986 21.625 15.9986Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 19.7486C18.4963 19.7486 19 19.2449 19 18.6236C19 18.0023 18.4963 17.4986 17.875 17.4986C17.2537 17.4986 16.75 18.0023 16.75 18.6236C16.75 19.2449 17.2537 19.7486 17.875 19.7486Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.625 19.7486C22.2463 19.7486 22.75 19.2449 22.75 18.6236C22.75 18.0023 22.2463 17.4986 21.625 17.4986C21.0037 17.4986 20.5 18.0023 20.5 18.6236C20.5 19.2449 21.0037 19.7486 21.625 19.7486Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.375 19.7486C10.9963 19.7486 11.5 19.2449 11.5 18.6236C11.5 18.0023 10.9963 17.4986 10.375 17.4986C9.75368 17.4986 9.25 18.0023 9.25 18.6236C9.25 19.2449 9.75368 19.7486 10.375 19.7486Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.125 19.7486C14.7463 19.7486 15.25 19.2449 15.25 18.6236C15.25 18.0023 14.7463 17.4986 14.125 17.4986C13.5037 17.4986 13 18.0023 13 18.6236C13 19.2449 13.5037 19.7486 14.125 19.7486Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.375 23.4986C10.9963 23.4986 11.5 22.9949 11.5 22.3736C11.5 21.7523 10.9963 21.2486 10.375 21.2486C9.75368 21.2486 9.25 21.7523 9.25 22.3736C9.25 22.9949 9.75368 23.4986 10.375 23.4986Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.125 23.4986C14.7463 23.4986 15.25 22.9949 15.25 22.3736C15.25 21.7523 14.7463 21.2486 14.125 21.2486C13.5037 21.2486 13 21.7523 13 22.3736C13 22.9949 13.5037 23.4986 14.125 23.4986Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 23.4986C18.4963 23.4986 19 22.9949 19 22.3736C19 21.7523 18.4963 21.2486 17.875 21.2486C17.2537 21.2486 16.75 21.7523 16.75 22.3736C16.75 22.9949 17.2537 23.4986 17.875 23.4986Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6.2486V7.7486M10 6.2486V7.7486V6.2486Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 11.4986H6.25",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarOutlined);
export default __webpack_public_path__ + "static/media/CalendarOutlined.e7cd2c9c295151e1abfe682a140be211.svg";
export { ForwardRef as ReactComponent };